module.exports = __webpack_public_path__ + "img/sq-15.b5ed2669.jpg";